import React from "react";
import { useRecoilState } from "recoil";
import { reportIDSelector } from "../../store/selectors";

const Billing = () => {
  const [reportID] = useRecoilState(reportIDSelector);

  return (
    <div className="text-center pb-40">
      En caso de necesitar una factura, rogamos envíen el código <br />
      <strong>{reportID}</strong> <br />y sus datos de facturación a{" "}
      <strong>info@kidodynamics.com</strong>
    </div>
  );
};

export default Billing;
